import { render, staticRenderFns } from "./IpAddressRestrictionPage.vue?vue&type=template&id=b767c776&scoped=true"
import script from "./IpAddressRestrictionPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./IpAddressRestrictionPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./IpAddressRestrictionPage.vue?vue&type=style&index=0&id=b767c776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b767c776",
  null
  
)

export default component.exports